<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import Clients from "../../../../src/components/clients/clients.vue";
/**
 * Starter component
 */
export default {
    page: {
        title: "Clients",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Clients },
    data() {
        return {
            title: "Clients",
            items: [
                // {
                //     text: "Clients",
                //     href: "/clients",
                // },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Clients />
    </Layout>
</template>
